<template>
<main>
    癌症早筛zbasdbsadbkadka
</main>
</template>

<script>
export default {
  name: "cancerDetectionP",
};
</script>

<style scoped lang='less'>
</style>


// WEBPACK FOOTER //
// src/components/product/cancerDetectionP.vue